export default __webpack_public_path__ + "static/media/nonimateCharityBackground.dd73fd6f.png";